<div class="toast-wrapper" *ngIf="visible">
  <div class="custom-toast d-flex align-items-start" [ngClass]="toastClass">
    <!-- Icono -->
    <div class="alert-icon mr-2">
      <!-- <svg *ngIf="type === 'error'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
           stroke="#b21b2d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg> -->
      <img src="assets/icons/icon_warning.png" alt="">

      <svg *ngIf="type === 'success'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
           stroke="#155724" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>

      <svg *ngIf="type === 'warning'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
           stroke="#856404" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>

      <svg *ngIf="type === 'info'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
           stroke="#0c5460" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
    </div>

    <!-- Texto -->
    <div class="message flex-fill">
      <strong>{{ title }}</strong>
      <small>{{ message }}</small>
    </div>

    <!-- Cerrar -->
    <!-- <button type="button" class="close close-btn ml-2 red-close" (click)="closeToast()">
      <span aria-hidden="true">&times;</span>
    </button> -->

    <img src="assets/icons/icon_clear.png" class="close-btn" (click)="closeToast()" alt="">
  </div>
</div>

